import { render, staticRenderFns } from "./LivingOptionsProperties.vue?vue&type=template&id=1077d7b8"
import script from "./LivingOptionsProperties.vue?vue&type=script&lang=js"
export * from "./LivingOptionsProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports